// extracted by mini-css-extract-plugin
export var aiChatCartContainer = "_d1-2";
export var aiChatCartContainerExit = "_d1-4";
export var aiChatContainerLarge = "_d1-0";
export var aiChatContainerSmall = "_d1-1";
export var aiChatIcon = "_d1-6";
export var slideInFromRight = "_d1-3";
export var slideOutToRight = "_d1-5";